import memoize from "fast-memoize";
import fetch from "./fetch-trade-api";

const years = memoize(async () => {
  const resp = await fetch("/v1/report/years");
  const years = await resp.json();
  return new Map(Object.entries(years));
});

export const label = async ({ yearId }) => {
  const map = await years();
  return map.get(yearId);
};

export default years;
